"use client";

import Link from "next/link";
import { Icon } from "@iconify/react";
import { cn } from "@/utils/cn";

type BreadcrumbProps = {
  className?: string;
  variant?: "homepage" | "articles";
};

export const Breadcrumb = ({
  className,
  variant = "homepage",
}: BreadcrumbProps) => {
  const href = variant === "articles" ? "/articles" : "/";
  const text =
    variant === "articles" ? "Retour aux articles" : "Retour à l'accueil";

  return (
    <section
      className={cn(
        "flex w-full flex-row justify-start px-4 pt-7 ph:px-24 md:px-48 lg:px-72 xl:px-96",
        className
      )}
    >
      <div>
        <Link href={href} className="group font-light text-accent">
          <div className="flex items-center gap-0.5">
            <Icon
              icon="mdi:chevron-left"
              className="h-5 w-5 text-accent transition-colors duration-300 group-hover:text-accent/75"
            />
            <span className="transition-colors duration-300 group-hover:text-accent/75">
              {text}
            </span>
          </div>
        </Link>
      </div>
    </section>
  );
};
